import script from "./MultiContactTypePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiContactTypePicker.vue?vue&type=script&lang=ts&setup=true"

import "./MultiContactTypePicker.vue?vue&type=style&index=0&id=9b8b25f8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b8b25f8"]])

export default __exports__